export default __webpack_public_path__ + "static/media/H4008.2.838b13fb.mp3";